import { Component } from 'solid-js';

interface HeatmapSectionLabelProps {
  readonly label: string;
  readonly uppercase?: boolean;
}

export const HeatmapSectionLabel: Component<HeatmapSectionLabelProps> = (
  props
) => (
  <span
    class={`m-0 text-sm font-medium text-gray-8${props.uppercase ? ' uppercase' : ''}`}
  >
    {props.label}
  </span>
);
